import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { StoreProvider } from './context/StoreContext';
import { LocaleProvider } from './context/LocaleContext';
import { TaxonomiesProvider } from './context/TaxonomiesContext';
import { Toaster } from './components/ui/toaster';
import SeoLangTags from './components/SeoLangTags';
import WolfSplash from './components/WolfSplash';
import AuthCallback from './components/AuthCallback';
import ErrorBoundary from './components/ErrorBoundary';
import Home from './pages/Home';
import ShopListing from './pages/ShopListing';
import ProductDetail from './pages/ProductDetail';
import Cart from './pages/Cart';
import Wishlist from './pages/Wishlist';
import MyOrders from './pages/MyOrders';
import AdminPage from './pages/AdminPage';
import AboutUs from './pages/AboutUs';
import ContactUs from './pages/ContactUs';
import TrackOrder from './pages/TrackOrder';
import FAQs from './pages/FAQs';
import ReturnsRefunds from './pages/ReturnsRefunds';
import GiftVouchers from './pages/GiftVouchers';
import PrivacyPolicy from './pages/PrivacyPolicy';
import ChatWidget from './components/ChatWidget';
import CookieConsent from './components/CookieConsent';

const SplashGate = () => {
  const { pathname, hash } = useLocation();
  if (pathname.startsWith('/feron-boss')) return null;
  if (hash && hash.includes('session_id=')) return null;
  return <WolfSplash />;
};

// Detect Google OAuth callback synchronously (hash routed) before normal routes
const AppRouter = () => {
  const location = useLocation();
  if (location.hash && location.hash.includes('session_id=')) {
    return <AuthCallback />;
  }
  return (
    <>
      <SplashGate />
      <SeoLangTags />
      <ErrorBoundary>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/shop/:gender" element={<ShopListing />} />
          <Route path="/shop/:gender/:category" element={<ShopListing />} />
          <Route path="/search" element={<ShopListing />} />
          <Route path="/product/:id" element={<ProductDetail />} />
          <Route path="/cart" element={<Cart />} />
          <Route path="/wishlist" element={<Wishlist />} />
          <Route path="/my-orders" element={<MyOrders />} />
          <Route path="/about-us" element={<AboutUs />} />
          <Route path="/contact-us" element={<ContactUs />} />
          <Route path="/track-order" element={<TrackOrder />} />
          <Route path="/gift-vouchers" element={<GiftVouchers />} />
          <Route path="/returns-refunds" element={<ReturnsRefunds />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/faqs" element={<FAQs />} />
          <Route path="/feron-boss" element={<AdminPage />} />
        </Routes>
      </ErrorBoundary>
      {location.pathname !== '/feron-boss' && <ChatWidget />}
      {location.pathname !== '/feron-boss' && <CookieConsent />}
    </>
  );
};

function App() {
  return (
    <div className="App">
      <LocaleProvider>
        <StoreProvider>
          <TaxonomiesProvider>
            <BrowserRouter>
              <AppRouter />
              <Toaster />
            </BrowserRouter>
          </TaxonomiesProvider>
        </StoreProvider>
      </LocaleProvider>
    </div>
  );
}

export default App;
